import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "search-block q-mb-xl" }
const _hoisted_2 = { class: "main-search-input" }
const _hoisted_3 = { class: "row items-start q-mb-md" }
const _hoisted_4 = { class: "label-header" }
const _hoisted_5 = { class: "header-top-row bold" }
const _hoisted_6 = ["disabled", "value"]
const _hoisted_7 = { class: "label-container" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row items-start" }
const _hoisted_11 = { class: "label-header" }
const _hoisted_12 = { class: "header-top-row bold" }
const _hoisted_13 = ["disabled", "value"]
const _hoisted_14 = { class: "label-container" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "row items-center q-col-gutter-x-md" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "recent-product" }
const _hoisted_20 = { class: "card-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _directive_shortkey = _resolveDirective("shortkey")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_q_input, {
        class: "search-input",
        "model-value": _ctx.searchValue,
        "onUpdate:modelValue": _ctx.emitSearchQuery,
        onKeyup: [
          _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.emitSaveSearchQuery($event, _ctx.searchValue, false)), ["enter"])),
          _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('update:searchValue', '')), ["esc"]))
        ],
        onClear: _ctx.resetSearch,
        "clear-icon": "close",
        tabindex: "0",
        placeholder: "Search or scan products by sku, ean, title and more...",
        outlined: "",
        clearable: ""
      }, {
        prepend: _withCtx(() => _cache[6] || (_cache[6] = [
          _createElementVNode("div", {
            class: "t-icon",
            style: {"font-style":"normal"}
          }, "W", -1)
        ])),
        _: 1
      }, 8, ["model-value", "onUpdate:modelValue", "onClear"])), [
        [
          _directive_shortkey,
          {ctrl: ['ctrl', 'f'], meta: ['meta', 'f']},
          void 0,
          { focus: true }
        ]
      ]),
      (_ctx.active)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            class: "reset-btn danger q-ml-sm",
            onClick: _ctx.resetSearch,
            color: "error",
            unelevated: "",
            rounded: "",
            outline: ""
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "t-icon error" }, "^", -1),
              _createElementVNode("span", null, "Reset", -1)
            ])),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_btn, {
            class: _normalizeClass(["cat-search search-btn", {active: _ctx.categorySearch !== null}]),
            disabled: _ctx.selectedCategories.length >= 20,
            flat: "",
            round: "",
            size: "xs",
            color: "primary",
            icon: _ctx.categorySearch === null ? 'search' : 'undo',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchBtnClick('update:category-search', _ctx.categorySearch, _ctx.categorySearchInput)))
          }, null, 8, ["disabled", "icon", "class"]),
          _cache[8] || (_cache[8] = _createTextVNode("Categories"))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["search-input-container", { active: _ctx.categorySearch !== null, disabled: _ctx.selectedCategories.length >= 20 }])
        }, [
          _createElementVNode("input", {
            type: "text",
            disabled: _ctx.selectedCategories.length >= 20,
            size: "1",
            placeholder: "Search for category",
            value: _ctx.categorySearch,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:category-search', ($event.target as HTMLInputElement)?.value))),
            ref: "categorySearchInput"
          }, null, 40, _hoisted_6)
        ], 2),
        (_ctx.selectedCategories.length >= 20)
          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("You can only select up to 20 categories")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCategories.slice(0, _ctx.categoryLimit), (category) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["label", {active: _ctx.selectedCategories.includes(category.sys.id)}]),
            onClick: ($event: any) => (_ctx.emitCategoryId(category.sys.id)),
            key: category.sys.id
          }, _toDisplayString(category.name), 11, _hoisted_8))
        }), 128)),
        (!_ctx.filteredCategories.length)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_9, "No categories available"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_q_btn, {
            class: _normalizeClass(["brand-search search-btn", {active: _ctx.brandSearch !== null}]),
            disabled: _ctx.selectedBrands.length >= 20,
            flat: "",
            round: "",
            size: "xs",
            color: "primary",
            icon: _ctx.brandSearch === null ? 'search' : 'undo',
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearchBtnClick('update:brand-search', _ctx.brandSearch, _ctx.brandSearchInput)))
          }, null, 8, ["disabled", "icon", "class"]),
          _cache[10] || (_cache[10] = _createTextVNode("Brands"))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["search-input-container", { active: _ctx.brandSearch !== null, disabled: _ctx.selectedBrands.length >= 20 }])
        }, [
          _createElementVNode("input", {
            type: "text",
            disabled: _ctx.selectedBrands.length >= 20,
            size: "1",
            placeholder: "Search for brand",
            value: _ctx.brandSearch,
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:brand-search', ($event.target as HTMLInputElement)?.value))),
            ref: "brandSearchInput"
          }, null, 40, _hoisted_13)
        ], 2),
        (_ctx.selectedBrands.length >= 20)
          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("You can only select up to 20 brands")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBrands.slice(0, _ctx.brandLimit), (brandObj) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["label", {active: _ctx.selectedBrands.includes(brandObj.brand)}]),
            onClick: ($event: any) => (_ctx.emitBrand(brandObj.brand)),
            key: brandObj.sys.id
          }, _toDisplayString(brandObj.brand), 11, _hoisted_15))
        }), 128)),
        (!_ctx.filteredBrands?.length)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_16, "No brands available"))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row items-center" }, [
      _createElementVNode("h5", {
        class: "bold",
        style: {"margin-top":"1.2rem"}
      }, "Recently visited")
    ], -1)),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentProducts, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "recent-product-container col-4",
          onClick: ($event: any) => (_ctx.productRoute(product.sys.id))
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h5", _hoisted_20, _toDisplayString(product.title), 1),
            _createVNode(_component_ChevronRightIcon)
          ])
        ], 8, _hoisted_18))
      }), 256))
    ])
  ]))
}